import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;

  padding: 1rem;
  background-color: #212325;
  border-radius: 1rem;

  > img {
    border-radius: 1rem;
    width: 7rem;
    height: auto;
    object-fit: cover;
  }
`;
